import React from "react";
import { Switch, Redirect } from "react-router-dom";
import {
  Eligibilitys,
  EligibilitySummaryReports,
  NewEmployeeEligibilityReport,
  VestingSummaryReports,
  NewEmployeeVestingReport,
} from "../layouts";

import { ROUTES, MANAGE_ELIGIBILITY_ROUTES, ApplicationRoute } from "../utils";

const menu = "eligibility",
  flow = "edit";
export const ManageEligibilityRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_ELIGIBILITY_ROUTES.ELIGIBILITY}/:eligibilityId?`,
          `${MANAGE_ELIGIBILITY_ROUTES.ELIGIBILITY}/:flow(edit)/:eligibilityId?`,
        ]}
        component={Eligibilitys}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_ELIGIBILITY_ROUTES.ELIGIBILITY_SUMMARY_REPORTS}/:eligibilityId?`,
          `${MANAGE_ELIGIBILITY_ROUTES.ELIGIBILITY_SUMMARY_REPORTS}/:flow(edit)/:eligibilityId?`,
        ]}
        component={EligibilitySummaryReports}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_ELIGIBILITY_ROUTES.NEW_EMPLOYEE_ELIGIBILITY_REPORT}/:eligibilityId?`,
          `${MANAGE_ELIGIBILITY_ROUTES.NEW_EMPLOYEE_ELIGIBILITY_REPORT}/:flow(edit)/:eligibilityId?`,
        ]}
        component={NewEmployeeEligibilityReport}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_ELIGIBILITY_ROUTES.VESTING_SUMMARY_REPORTS}/:eligibilityId?`,
          `${MANAGE_ELIGIBILITY_ROUTES.VESTING_SUMMARY_REPORTS}/:flow(edit)/:eligibilityId?`,
        ]}
        component={VestingSummaryReports}
      />
      <ApplicationRoute
        exact
        menu={menu}
        flow={flow}
        path={[
          `${MANAGE_ELIGIBILITY_ROUTES.NEW_EMPLOYEE_VESTING_REPORT}/:eligibilityId?`,
          `${MANAGE_ELIGIBILITY_ROUTES.NEW_EMPLOYEE_VESTING_REPORT}/:flow(edit)/:eligibilityId?`,
        ]}
        component={NewEmployeeVestingReport}
      />

      <Redirect
        exact
        menu={menu}
        flow={flow}
        from={ROUTES.MANAGE_ELIGIBILITY}
        to={MANAGE_ELIGIBILITY_ROUTES.ELIGIBILITY_SUMMARY_REPORTS}
      />
      <Redirect to={ROUTES.HOME} />
    </Switch>
  );
};
